import { render, staticRenderFns } from "./OrderRequestView.vue?vue&type=template&id=84e61980&scoped=true"
import script from "./OrderRequestView.vue?vue&type=script&lang=js"
export * from "./OrderRequestView.vue?vue&type=script&lang=js"
import style0 from "./OrderRequestView.vue?vue&type=style&index=0&id=84e61980&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "84e61980",
  null
  
)

export default component.exports